<template>
  <footer class="c-Footer">
    <section class="c-Footer__main main-container">
      <div class="content-container">
        <div class="c-Footer__navBlock">
          <nav class="c-Footer__nav">
            <p>About Air Liberty</p>
            <ul>
              <li><a href="#">About us</a></li>
              <li><a href="#">Careers</a></li>
              <li><a href="#">News Hub</a></li>
              <li><a href="#">Investor Relations</a></li>
              <li><a href="#">Business Travel</a></li>
              <li><a href="#">Travel Agents</a></li>
              <li><a href="#">Mobile App</a></li>
            </ul>
          </nav>
          <nav class="c-Footer__nav">
            <p>Customer Service</p>
            <ul>
              <li><a href="https://d3v-flyairliberty.zendesk.com/hc/" target="_blank" rel="noopener noreferrer">Need Help?</a></li>
              <li><a href="#">Tweet Us</a></li>
              <li><a href="#">Comment/Complaint</a></li>
            </ul>
          </nav>
          <nav class="c-Footer__nav">
            <p>Site Support</p>
            <ul>
              <li><a href="#">Login Help</a></li>
              <li><a href="#">Site Map</a></li>
              <li><a href="#">Browser Compatibility</a></li>
              <li><a href="#">Accessibility</a></li>
              <li><a href="#">Booking Information</a></li>
            </ul>
          </nav>
          <nav class="c-Footer__nav">
            <p>Policies</p>
            <ul>
              <li><a href="#">Customer Commitment</a></li>
              <li><a href="#">Tarmac Delay Plan</a></li>
              <li><a href="#">Sustainability</a></li>
              <li><a href="#">Contract of Carriage</a></li>
              <li><a href="#">Cookies, Privacy</a></li>
              <li><a href="#">Legal</a></li>
            </ul>
          </nav>
        </div>
        <div class="c-Footer__socialCopyBlock">
          <div class="c-Footer__social">
            <i class="linkedin"></i>
            <i class="facebook"></i>
            <i class="twitter"></i>
            <i class="youtube"></i>
            <i class="instagram"></i>
          </div>
          <div class="c-Footer__copy">
            <nav class="c-Footer__navSecondary">
              <ul>
                <li class="copy">&#169;2020 Air Liberty</li>
                <li><a href="#">General Conditions of Carriage</a></li>
                <li><a href="#">Data Protection</a></li>
                <li><a href="#">Passenger rights</a></li>
                <li><a href="#">Terms of Use</a></li>
              </ul>
            </nav>
          </div>
        </div>
        <p class="c-Footer__disclaimer"><span>Disclaimer:</span> Air Liberty is an <a href="https://unbabel.com/" target="_blank" rel="noopener noreferrer">Unbabel</a> demo company and unfortunately you can't actually fly anywhere with us. On the bright side, it means that we have very low carbon emissions.</p>
      </div>
    </section>
    <section class="c-Footer__secondary main-container">
      <div class="content-container">
        <img title="Air Liberty Logo White" src="@/assets/air_liberty_footer.svg">
        <div class="c-Footer__secondaryRightBlock">
          <span>Proud member</span>
          <img title="Sky World Alliance Logo" src="@/assets/sky_world.svg">
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
// import Button from '@/components/Button'

export default {
  name: 'Footer',
  components: {
    // Button
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/variables.scss";

.c-Footer {
  &__main {
    background-color: $blue;

    .content-container {
      display: block;
      padding: 40px 0 45px 0;
    }
  }

  &__navBlock {
    display: flex;
    align-items: flex-start;
  }

  &__socialCopyBlock {
    margin-top: calc(#{$base-margin * 2});
    width: 100%;
    display: flex;
    align-items: center;
  }

  &__social {
    width: 25%;
    display: flex;
    align-items: center;

    i {
      height: 28px;
      display: block;
      background-size: cover;
      background-position: top center;
      background-repeat: no-repeat;
      cursor: pointer;
      margin-right: $base-margin;

      &.linkedin {
        background-image: url('~@/assets/linkedin.svg');
        width: 28px;
      }

      &.facebook {
        background-image: url('~@/assets/facebook.svg');
        width: 28px;
      }

      &.twitter {
        background-image: url('~@/assets/twitter.svg');
        width: 36px;
      }

      &.youtube {
        background-image: url('~@/assets/youtube.svg');
        width: 39px;
      }

      &.instagram {
        background-image: url('~@/assets/instagram.svg');
        width: 28px;
      }
    }
  }

  &__nav {
    width: 25%;
    text-align: left;
    font-size: 14px;

    p {
      font-size: 14px;
      font-weight: bold;
      color: $orange;
      margin-bottom: $base-margin;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      display: block;

      li {
        margin: 0 0 calc(#{$base-margin} / 2);
        padding: 0;
      }

      a {
        color: #FFFFFF;
        font-size: 14px;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  &__navSecondary {
    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      display: flex;
      align-items: center;

      li {
        margin: 0 $base-margin 0 0;
        padding: 0;

        &.copy {
          font-weight: bold;
          color: white;
          font-size: 14px;
        }
      }

      a {
        color: #FFFFFF;
        font-size: 14px;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  &__secondary {
    background-color: $dark-blue;

    .content-container {
      justify-content: space-between;
      align-items: center;
      padding: $base-padding 0;
    }
  }

  &__secondaryRightBlock {
    display: flex;
    align-items: center;

    span {
      font-size: 12px;
      color: #FFFFFF;
      margin-right: $base-margin;
    }

    img {
      height: 17px;
    }
  }

  &__disclaimer {
    text-align: left;
    color: #FFFFFF;
    margin-top: calc(#{$base-margin} * 2);
    line-height: 1.5rem;

    span {
      font-weight: 600;
      margin-right: 5px;
    }

    a {
      text-decoration: underline;
      color: #FFFFFF;
    }
  }
}

@include desktop-sm {
  .c-Footer {
    &__socialCopyBlock {
      display: block;
    }

    &__social {
      width: 100%;
      margin-bottom: calc(#{$base-margin} * 2);
      justify-content: center;
    }
    &__copy {
      display: flex;
      justify-content: center;
    }

    &__disclaimer {
      text-align: center;
      padding: 0 $base-margin;
    }
  }
}

@include phone {
  .c-Footer {
    .content-container {
      padding: 40px 0 25px 0;
    }
    &__navBlock {
      flex-flow: wrap;
    }
    &__nav {
      width: 50%;
      margin-bottom: calc(#{$base-margin} * 2);
      padding: 0 $base-padding;
      text-align: center;

      li {
        margin-bottom: $base-margin !important;
      }

      a {
        line-height: 20px;
      }
    }

    &__socialCopyBlock {
      margin-top: $base-margin;
    }

    &__navSecondary ul {
      flex-flow: wrap;
      justify-content: center;
      margin-top: $base-margin;

      li {
        margin-bottom: $base-margin;
      }
    }
  }
}
</style>
